import NavLinks from "./NavLinks";

const Navigation = ({ setIsOpen, isLoggedIn, user }) => {
  return (
    <div className="hidden lg:flex flex-grow ml-8 justify-end">
      <NavLinks close={setIsOpen} isLoggedIn={isLoggedIn} user={user} />
    </div>
  );
};

export default Navigation;
